import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function EcuadorPobrezaRuralLayer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="TIPOLOGIA_MICRORREGIONES_AGRICOLA_PECUARIO_pobreza_rural"
      format="image/png"
      version="1.1.1"
      transparent
      tiled
      url={`https://g8a078u1g6.execute-api.eu-west-1.amazonaws.com/app/wms-ecuador/agroestadistica/tipologias_territorio_hih/wms`}
      opacity={opacity}
    />
  )
}

export default EcuadorPobrezaRuralLayer
